export default __webpack_public_path__ + "static/media/thumnail-3.358e236e.jpg";